import { useFieldArray, useFormContext } from "react-hook-form";

import { FormValues } from "./just-before-logout-modal";
import { DataTable } from "./new-documents-table/data-table";
import { columns } from "./new-documents-table/columns";

interface WorkAttachmentsProps {
  isPending: boolean;
}

export const WorkAttachments = ({ isPending }: WorkAttachmentsProps) => {
  const form = useFormContext<FormValues>();

  const {
    fields: documentFields,
    append: appendDocument,
    remove: removeDocument,
    update: updateDocument,
  } = useFieldArray({
    name: "attachments",
    control: form.control,
  });

  return (
    <div className="flex flex-col">
      <h2 className="text-lg font-medium">Attachments</h2>

      <DataTable
        isPending={isPending}
        columns={columns}
        data={documentFields}
        removeDocumentRow={removeDocument}
        appendDocumentRow={appendDocument}
        updateDocumentRow={updateDocument}
      />
    </div>
  );
};
